var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.729 17.7927C13.1087 17.7926 13.4167 18.1003 13.4167 18.48C13.4167 18.8597 13.109 19.1676 12.7294 19.1677L0.812702 19.1711C0.433 19.1712 0.125 18.8635 0.125 18.4838C0.125 18.1041 0.432606 17.7962 0.812299 17.7961L12.729 17.7927ZM6.67752 0.845146L6.77083 0.838867C7.11889 0.838867 7.40654 1.0975 7.4521 1.43308L7.45833 1.52637L7.45742 14.071L10.8691 10.6606C11.1132 10.4166 11.4951 10.3944 11.7643 10.5942L11.8414 10.6607C12.0854 10.9048 12.1076 11.2868 11.9078 11.5559L11.8413 11.633L7.26006 16.2132C7.01613 16.4572 6.63443 16.4794 6.3653 16.28L6.28821 16.2135L1.70169 11.6333C1.43303 11.365 1.43273 10.9297 1.70103 10.661C1.94494 10.4168 2.32687 10.3943 2.59615 10.5939L2.67331 10.6603L6.08242 14.0646L6.08333 1.52637C6.08333 1.17831 6.34202 0.890668 6.67752 0.845146Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.139a47af3909b5816989fdcecacdac7c.svg";
export { ForwardRef as ReactComponent };